import { DataBind } from "./DataBind.js";
import { isCheckbox } from "./utils.js";
class DataModel extends DataBind {
  static config = {
    name: "DataModel"
  };
  dispatch() {
    const { target, multiple } = this;
    let value = this.get();
    if (multiple && isCheckbox(target) && !target.checked) {
      const set = new Set(value);
      set.delete(target.value);
      value = Array.from(set);
    }
    for (const instance of this.relatedInstances) {
      instance.set(value, false);
    }
  }
  onInput() {
    this.dispatch();
  }
}
export {
  DataModel
};
//# sourceMappingURL=DataModel.js.map
